import React, { useContext } from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

import { BlogCardContext } from './BlogCardContext';

export const BlogCardType = ({
  children,
  className,
  as: Component = 'article',
  ...props
}: DefaultBsComponent) => {
  const context = useContext<any>(BlogCardContext);

  return (
    <Component
      className={classNames(
        'BlogCardType',
        className,
        ['top', 'bottom'].includes(context?.imgPosition) && 'flex flex-col',
        ['right', 'left'].includes(context?.imgPosition) &&
          'md:h-[450px] md:gap-24 py-24 sm:py-32 px-16 sm:px-24 md:p-40',
        context?.imgPosition === 'right' && 'md:flex-row',
        context?.imgPosition === 'left' && 'md:flex-row-reverse',

        'md:relative flex h-full',
      )}
      {...props}
    >
      {children}
    </Component>
  );
};
